import { create } from 'zustand';

type PaletteState = {
  open: boolean;
  query: string;
  show: () => void;
  hide: () => void;
  toggle: () => void;
  setQuery: (q: string) => void;
};

export const usePaletteStore = create<PaletteState>((set, get) => ({
  open: false,
  query: '',
  show: () => set({ open: true, query: '' }),
  hide: () => set({ open: false }),
  toggle: () => set({ open: !get().open, query: '' }),
  setQuery: (q) => set({ query: q }),
}));
